var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { RoomDamageComponent } from '../RoomDamageComponent';
import SurfaceSlider from '@declaration/components/roomDamage/surfaceDamage/SurfaceSlider.vue';
import SurfaceDamagesInput from '@declaration/components/roomDamage/surfaceDamage/SurfaceDamagesInput.vue';
import PictureCollectionUpload from '@declaration/components/upload/PictureCollectionUpload.vue';
import { SurfaceType } from '@shared/types/api/roomDamage';
import { ClaimFileType } from '@shared/types/file';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const settings = namespace('settings');
const qualification = namespace('qualification');
let SurfaceDamagesForm = class SurfaceDamagesForm extends RoomDamageComponent {
    constructor() {
        super(...arguments);
        this.surfaceTypeLabels = SurfaceType;
        this.fileType = ClaimFileType.RoomDamage;
    }
    get pictureCollection() {
        return this.roomDamage.pictureCollection;
    }
    set pictureCollection(pictureCollection) {
        this.updateRoomDamage({ pictureCollection });
    }
    get hasDisableDamagesPictures() {
        return insurerHasFeature(InsurerFeatureFlag.DisableDamagesPictures);
    }
    get requiredPhotos() {
        if (!this.setting)
            return 0;
        const trigram = this.trigram;
        if (!trigram)
            return 0;
        let rawValue = null;
        try {
            rawValue = this.setting(`damageRequiredPhotosCount${trigram}`);
        }
        catch (_a) {
            rawValue = null;
        }
        if (rawValue === undefined || rawValue === null) {
            try {
                const groupedSetting = this.setting('damageRequiredPhotosCount');
                if (groupedSetting && typeof groupedSetting === 'object') {
                    rawValue = groupedSetting[trigram];
                }
            }
            catch (_b) {
                rawValue = null;
            }
        }
        const value = Number(rawValue);
        return isNaN(value) ? 0 : value;
    }
    get hasEnoughPhotos() {
        var _a, _b;
        const uploadedFiles = (_b = (_a = this.pictureCollection) === null || _a === void 0 ? void 0 : _a.uploadedAppFiles) !== null && _b !== void 0 ? _b : [];
        return uploadedFiles.length >= this.requiredPhotos;
    }
    onPictureCollectionUpdate(pictureCollection) {
        this.pictureCollection = pictureCollection;
    }
};
__decorate([
    settings.Getter('setting')
], SurfaceDamagesForm.prototype, "setting", void 0);
__decorate([
    qualification.Getter('typeTrigram')
], SurfaceDamagesForm.prototype, "trigram", void 0);
__decorate([
    qualification.State('claim')
], SurfaceDamagesForm.prototype, "claim", void 0);
SurfaceDamagesForm = __decorate([
    Component({
        components: { SurfaceSlider, SurfaceDamagesInput, PictureCollectionUpload },
        props: {
            validateRequested: { type: Boolean, default: false },
        },
    })
], SurfaceDamagesForm);
export default SurfaceDamagesForm;
